import React from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';

/**
 * Date Range Picker Component
 * Simple date range selection for dashboard filters
 */
const DateRangePicker = ({
  startDate,
  endDate,
  onChange,
  className = ''
}) => {
  const handleStartDateChange = (e) => {
    onChange({ startDate: e.target.value, endDate });
  };

  const handleEndDateChange = (e) => {
    onChange({ startDate, endDate: e.target.value });
  };

  // Quick date range presets
  const applyThisMonth = () => {
    const end = new Date();
    const start = new Date(end.getFullYear(), end.getMonth(), 1);
    onChange({
      startDate: start.toISOString().split('T')[0],
      endDate: end.toISOString().split('T')[0],
    });
  };

  const applyLastDays = (days) => {
    const end = new Date();
    const start = new Date();
    start.setDate(start.getDate() - days);
    onChange({
      startDate: start.toISOString().split('T')[0],
      endDate: end.toISOString().split('T')[0],
    });
  };

  const quickRanges = [
    { label: 'This month', apply: applyThisMonth },
    { label: 'Last 7 days', apply: () => applyLastDays(7) },
    { label: 'Last 30 days', apply: () => applyLastDays(30) },
    { label: 'Last 90 days', apply: () => applyLastDays(90) },
  ];

  return (
    <div className={`flex flex-col gap-1.5 sm:gap-2 ${className}`}>
      <div className="flex flex-row gap-2">
        <div className="flex-1">
          <label className="block text-xs font-medium mb-0.5">
            Start Date
          </label>
          <Input
            type="date"
            value={startDate}
            onChange={handleStartDateChange}
            className="text-xs sm:text-sm h-8"
          />
        </div>
        <div className="flex-1">
          <label className="block text-xs font-medium mb-0.5">
            End Date
          </label>
          <Input
            type="date"
            value={endDate}
            onChange={handleEndDateChange}
            className="text-xs sm:text-sm h-8"
          />
        </div>
      </div>
      <div className="flex items-center gap-1 flex-wrap">
        {quickRanges.map((range) => (
          <Button
            key={range.label}
            onClick={range.apply}
            variant="outline"
            size="sm"
            className="text-xs h-7 flex-1 sm:flex-none min-w-[70px] sm:min-w-[90px]"
          >
            {range.label}
          </Button>
        ))}
      </div>
    </div>
  );
};

export default DateRangePicker;
